export const ELECTION_RESOLUTION_DATE = new Date('2020-11-03T08:00:00.000Z');
export const ELECTION_REFUND_DATE = new Date('2021-01-30T00:00:00.000Z');

export const ELECTION_BETTING_END_DATE = new Date(1604455200000); // Tue Nov 03 2020 21:00:00 GMT-0500 (Eastern Standard Time) {}
// Test value: 1704455200000

export const FIRST_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-01T00:00:00.000Z'
);
export const SECOND_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-02T00:00:00.000Z'
);
export const THIRD_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-03T00:00:00.000Z'
);
export const FOURTH_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-04T00:00:00.000Z'
);
export const FIFTH_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-05T00:00:00.000Z'
);
export const SIXTH_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-06T00:00:00.000Z'
);
export const SEVENTH_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-07T00:00:00.000Z'
);
export const EIGHTH_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-08T00:00:00.000Z'
);
export const NINTH_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-09T00:00:00.000Z'
);
export const THIRTYITH_TEST_ELECTION_RESOLUTION_DATE = new Date(
  '2020-10-30T00:00:00.000Z'
);

export const PROPER_RESOLUTION_DATES = [
  ELECTION_RESOLUTION_DATE,
  FIRST_TEST_ELECTION_RESOLUTION_DATE,
  SECOND_TEST_ELECTION_RESOLUTION_DATE,
  THIRD_TEST_ELECTION_RESOLUTION_DATE,
  FOURTH_TEST_ELECTION_RESOLUTION_DATE,
  FIFTH_TEST_ELECTION_RESOLUTION_DATE,
  SIXTH_TEST_ELECTION_RESOLUTION_DATE,
  SEVENTH_TEST_ELECTION_RESOLUTION_DATE,
  EIGHTH_TEST_ELECTION_RESOLUTION_DATE,
  NINTH_TEST_ELECTION_RESOLUTION_DATE,
  THIRTYITH_TEST_ELECTION_RESOLUTION_DATE
];
